/**
 * Surface inheritance for portalled kit content. Dialog, DropdownMenu and Tooltip render
 * through a Portal to document.body, outside the `.stars-dark` region a client page sits
 * in, so their semantic roles would resolve light. DESIGN.md: a region turns dark by
 * wrapping it in `.stars-dark`. Each root renders a hidden anchor where it sits in the page,
 * reads whether that spot is inside `.stars-dark`, and its Content wrapper re-applies the
 * class to the card. The `surface` prop ("dark" | "light") overrides the lookup.
 */
import React, { createContext, useContext, useLayoutEffect, useRef, useState } from 'react';

const SurfaceContext = createContext(false);

export function SurfaceRoot({ surface, children }) {
  const anchor = useRef(null);
  const [inherited, setInherited] = useState(false);
  useLayoutEffect(() => {
    setInherited(Boolean(anchor.current?.closest('.stars-dark')));
  }, []);
  const dark = surface ? surface === 'dark' : inherited;
  return (
    <SurfaceContext.Provider value={dark}>
      <span ref={anchor} hidden aria-hidden="true" />
      {children}
    </SurfaceContext.Provider>
  );
}

/** The class a portalled Content wrapper adds: `stars-dark` when its root sits on a dark surface. */
export function useSurfaceClass() {
  return useContext(SurfaceContext) ? 'stars-dark' : undefined;
}
